import { useState } from "react"
import { useSelector } from "react-redux"
import CountdownTimer from "./CountdownTimer"
import { associate } from "../Hashconnect"
import { claimToken, getUserData, updateToken } from "../services/API"
import Modal from "react-modal"
import { INFT } from "../Interfaces/NFT"
import { requestNFT } from "../services/HederaServices"

function DailyRewards({ setLoading, setLoadingMessage, setIsAssociationSuccessful }: any) {
    const isFirstTierAssociated = useSelector((state: any) => state.user.isFirstTierAssociated)
    const isSecondTierAssociated = useSelector((state: any) => state.user.isSecondTierAssociated)
    const isThirdTierAssociated = useSelector((state: any) => state.user.isThirdTierAssociated)
    const isFifthTierAssociated = useSelector((state: any) => state.user.isFifthTierAssociated)
    const dailyClaimsAmount = useSelector((state: any) => state.user.dailyClaimsAmount)
    const savedDateInSeconds = useSelector((state: any) => state.user.savedDateInSeconds)
    const canClaimDaily =  useSelector((state: any) => state.user.canClaimDaily)
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [token, setToken] = useState<INFT>();

    async function closeModal() {
        setShowSuccessModal(false);
    }

    async function claim() {
        try {
            setLoadingMessage("Generating Transaction...")
            setLoading(true)
            const operation: any = await claimToken();

            if (operation) {
                // const status: any = await updateToken(operation.serials, operation.tokenId)
                await getTokenData(operation.tokenId, operation.serials)
                await getUserData()
                // setShowSuccessModal(true)
                } else {
                    setShowSuccessModal(false)
                }
           
            setLoading(false)
            setLoadingMessage("Loading...")
        } catch (error) {

        }
    }

    async function getTokenData(token_id: any, serial: any) {
        const nft: INFT = await requestNFT(token_id, serial)
        setToken(nft)
        setShowSuccessModal(true)
    }

    async function associateToken() {
        try {
            setLoading(true)
            await associate(setIsAssociationSuccessful);
            setTimeout(async () => {
                await getUserData()
              }, 2000);
            setLoading(false)
        } catch (error) {

        }
    }


    return (
        <>

            {(dailyClaimsAmount >= 2000)
                    ?
                    <>
                        <div className="reward rewardDailyLogin claimed">
                            <span className="rewardsTitle">Daily Login R<span>e</span>ward</span>
                            <div className="rewardImage"></div>
                            <div className="btnRewards claimed">LIMIT REACHED  <span className="icoLocked material-symbols-outlined">lock</span></div>
                        </div>
                    </>
                    :
                (isFifthTierAssociated
                    && isFirstTierAssociated
                    && isSecondTierAssociated
                    && isThirdTierAssociated
                    && !canClaimDaily)
                    ?
                    <>
                        <div className="reward rewardDailyLogin claimed">
                        <span className="rewardsTitle">Daily Login R<span>e</span>ward</span>
                            <div className="rewardImage"></div>
                            <CountdownTimer savedDateInSeconds={savedDateInSeconds} />
                        </div>
                    </>
                    :
                    (!isFifthTierAssociated
                        && !isFirstTierAssociated
                        && !isSecondTierAssociated
                        && !isThirdTierAssociated
                        && canClaimDaily
                    )
                        ?
                        <>
                            <div className="reward rewardDailyLogin notClaimed">
                            <span className="rewardsTitle">Daily Login R<span>e</span>ward</span>
                                <div className="rewardImage"></div>
                                <div className="btnRewards" onClick={associateToken}>ASSOCIATE TOKENS <span className="icoProgress material-symbols-outlined">settings_alert</span></div>
                            </div>
                        </>
                        :
                        (isFifthTierAssociated
                            && isFirstTierAssociated
                            && isSecondTierAssociated
                            && isThirdTierAssociated
                            && canClaimDaily)
                            ?
                            <>
                                <div className="reward rewardDailyLogin notClaimed">
                                <span className="rewardsTitle">Daily Login R<span>e</span>ward</span>
                                    <div className="rewardImage"></div>
                                    <div className="btnRewards" onClick={() => claim()}>CLAIM <span className="icoTask material-symbols-outlined">emoji_events</span></div>
                                </div>
                            </>
                            :
                            <>
                                <div className="reward rewardDailyLogin claimed">
                                <span className="rewardsTitle">Daily Login R<span>e</span>ward</span>
                                    <div className="rewardImage"></div>
                                    <div className="btnRewards claimed">LOCKED  <span className="icoLocked material-symbols-outlined">lock</span></div>
                                </div>
                            </>
            }


            <Modal
                ariaHideApp={false}
                isOpen={showSuccessModal}
                onRequestClose={closeModal}
                contentLabel="My dialog"
                className="mymodal"
                overlayClassName="myoverlay"
                closeTimeoutMS={500}>
                <div className='close'>
                    <button className="btn modal-btn float-right" onClick={closeModal}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M3 16.74L7.76 12L3 7.26L7.26 3L12 7.76L16.74 3L21 7.26L16.24 12L21 16.74L16.74 21L12 16.24L7.26 21L3 16.74m9-3.33l4.74 4.75l1.42-1.42L13.41 12l4.75-4.74l-1.42-1.42L12 10.59L7.26 5.84L5.84 7.26L10.59 12l-4.75 4.74l1.42 1.42L12 13.41Z" /></svg>
                    </button>
                </div>
                {(token) ?
                    <>
                        <div>
                            <br></br><br></br>
                            <h3 className="ml-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path fill="#DD2E44" d="M11.626 7.488a1.413 1.413 0 0 0-.268.395l-.008-.008L.134 33.141l.011.011c-.208.403.14 1.223.853 1.937c.713.713 1.533 1.061 1.936.853l.01.01L28.21 24.735l-.008-.009c.147-.07.282-.155.395-.269c1.562-1.562-.971-6.627-5.656-11.313c-4.687-4.686-9.752-7.218-11.315-5.656z" /><path fill="#EA596E" d="M13 12L.416 32.506l-.282.635l.011.011c-.208.403.14 1.223.853 1.937c.232.232.473.408.709.557L17 17l-4-5z" /><path fill="#A0041E" d="M23.012 13.066c4.67 4.672 7.263 9.652 5.789 11.124c-1.473 1.474-6.453-1.118-11.126-5.788c-4.671-4.672-7.263-9.654-5.79-11.127c1.474-1.473 6.454 1.119 11.127 5.791z" /><path fill="#AA8DD8" d="M18.59 13.609a.99.99 0 0 1-.734.215c-.868-.094-1.598-.396-2.109-.873c-.541-.505-.808-1.183-.735-1.862c.128-1.192 1.324-2.286 3.363-2.066c.793.085 1.147-.17 1.159-.292c.014-.121-.277-.446-1.07-.532c-.868-.094-1.598-.396-2.11-.873c-.541-.505-.809-1.183-.735-1.862c.13-1.192 1.325-2.286 3.362-2.065c.578.062.883-.057 1.012-.134c.103-.063.144-.123.148-.158c.012-.121-.275-.446-1.07-.532a.998.998 0 0 1-.886-1.102a.997.997 0 0 1 1.101-.886c2.037.219 2.973 1.542 2.844 2.735c-.13 1.194-1.325 2.286-3.364 2.067c-.578-.063-.88.057-1.01.134c-.103.062-.145.123-.149.157c-.013.122.276.446 1.071.532c2.037.22 2.973 1.542 2.844 2.735c-.129 1.192-1.324 2.286-3.362 2.065c-.578-.062-.882.058-1.012.134c-.104.064-.144.124-.148.158c-.013.121.276.446 1.07.532a1 1 0 0 1 .52 1.773z" /><path fill="#77B255" d="M30.661 22.857c1.973-.557 3.334.323 3.658 1.478c.324 1.154-.378 2.615-2.35 3.17c-.77.216-1.001.584-.97.701c.034.118.425.312 1.193.095c1.972-.555 3.333.325 3.657 1.479c.326 1.155-.378 2.614-2.351 3.17c-.769.216-1.001.585-.967.702c.033.117.423.311 1.192.095a1 1 0 1 1 .54 1.925c-1.971.555-3.333-.323-3.659-1.479c-.324-1.154.379-2.613 2.353-3.169c.77-.217 1.001-.584.967-.702c-.032-.117-.422-.312-1.19-.096c-1.974.556-3.334-.322-3.659-1.479c-.325-1.154.378-2.613 2.351-3.17c.768-.215.999-.585.967-.701c-.034-.118-.423-.312-1.192-.096a1 1 0 1 1-.54-1.923z" /><path fill="#AA8DD8" d="M23.001 20.16a1.001 1.001 0 0 1-.626-1.781c.218-.175 5.418-4.259 12.767-3.208a1 1 0 1 1-.283 1.979c-6.493-.922-11.187 2.754-11.233 2.791a.999.999 0 0 1-.625.219z" /><path fill="#77B255" d="M5.754 16a1 1 0 0 1-.958-1.287c1.133-3.773 2.16-9.794.898-11.364c-.141-.178-.354-.353-.842-.316c-.938.072-.849 2.051-.848 2.071a1 1 0 1 1-1.994.149c-.103-1.379.326-4.035 2.692-4.214c1.056-.08 1.933.287 2.552 1.057c2.371 2.951-.036 11.506-.542 13.192a1 1 0 0 1-.958.712z" /><circle cx="25.5" cy="9.5" r="1.5" fill="#5C913B" /><circle cx="2" cy="18" r="2" fill="#9266CC" /><circle cx="32.5" cy="19.5" r="1.5" fill="#5C913B" /><circle cx="23.5" cy="31.5" r="1.5" fill="#5C913B" /><circle cx="28" cy="4" r="2" fill="#FFCC4D" /><circle cx="32.5" cy="8.5" r="1.5" fill="#FFCC4D" /><circle cx="29.5" cy="12.5" r="1.5" fill="#FFCC4D" /><circle cx="7.5" cy="23.5" r="1.5" fill="#FFCC4D" /></svg>
                                <span className="text-white">  Congratulations!</span>
                            </h3>
                            <br></br>
                            <center>
                            <img src={"/tiers/"+token.token_id+".png"} width={'150px'} className='rounded mx-auto d-block mt-2 mb-3' alt="token" />
                            </center>
                            <br></br>
                            <h3 className='modal-text ml-5'>
                                <span className="mb-3">{token.description}</span>
                                <br></br><br></br>
                                <span> Token id: {token.token_id}</span>
                                <br></br>
                                <span className="mb-2"> Serial number: {token.serial_number}</span>
                                <br></br><br></br>
                                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><circle cx="17" cy="19" r="17" fill="#FFCC4D" /><ellipse cx="17.999" cy="26" fill="#664500" rx="2" ry="2.5" /><path fill="#664500" d="M8.111 21.383a1 1 0 0 1-.845-1.533c.916-1.453 3.701-3.938 7.69-2.962a1 1 0 0 1-.476 1.942c-3.604-.882-5.502 2.056-5.521 2.086a1.001 1.001 0 0 1-.848.467zm11.973-3.742a1 1 0 0 1-.634-1.774c3.176-2.604 6.762-1.562 8.215-.646a1 1 0 0 1-1.064 1.694c-.138-.084-3.052-1.823-5.884.499a.992.992 0 0 1-.633.227z" /><path fill="#E2A62D" d="M13.346 31.273a.75.75 0 0 1-.722-.954c.437-1.54.258-3.029-.49-4.086c-.497-.702-1.205-1.131-1.943-1.178c-.414-.025-.728-.382-.702-.795s.381-.751.795-.701c1.193.074 2.313.733 3.073 1.807c1.011 1.429 1.27 3.383.709 5.361a.749.749 0 0 1-.72.546zm11.037-3.061a.744.744 0 0 1-.412-.124c-1.167-.77-1.82-2.117-1.792-3.695c.029-1.635.809-3.153 1.984-3.869a.748.748 0 0 1 1.03.251a.748.748 0 0 1-.251 1.03c-.735.448-1.244 1.499-1.264 2.614c-.02 1.055.389 1.936 1.118 2.417a.75.75 0 0 1-.413 1.376z" /><path fill="#DD2E44" d="M17.179 2.72a.325.325 0 0 0-.189-.091S1.066-.394.377.214C-.311.823.74 16.998.74 16.998c.005.081.023.15.067.199c.604.684 4.758-2.004 9.279-6.001c4.522-3.998 7.697-7.792 7.093-8.476z" /><path fill="#EA596E" d="M.349.271a.486.486 0 0 0-.038.123C.47 1.765 2.006 13.046 2.963 16.572c1.436-.803 2.895-1.894 4.609-3.253C6.116 10.654 1.158.146.349.271z" /><path fill="#3B88C3" d="m29.902 29.229l-10.573-1.303c-1.13-.102-3.117-.112-3.015-1.902c.093-1.623 2.04-1.373 3.479-1.16l10.638 1.774l-.529 2.591z" /><path fill="#88C9F9" d="m30.43 26.639l-4.222-.724c-.494-.089-.934.647-.956 1.426c-.025.866.227 1.304.726 1.406l4.144.512l.308-2.62z" /><path fill="#3B88C3" d="m34.918 26.341l-2.622 2.411l-4.687-5.097l2.622-2.411a3.372 3.372 0 0 1 4.751.199l.135.147a3.373 3.373 0 0 1-.199 4.751z" /><ellipse cx="29.952" cy="26.203" fill="#88C9F9" rx="2.77" ry="3.462" transform="rotate(-42.597 29.954 26.205)" /><ellipse cx="29.952" cy="26.203" fill="#269" rx="1.385" ry="2.077" transform="rotate(-42.597 29.954 26.205)" /><circle cx="2.5" cy="33.5" r="1.5" fill="#55ACEE" /><circle cx="29" cy="2" r="2" fill="#55ACEE" /><path fill="#EA596E" d="M4.864 29.246L2.526 23.63L.412 29.675zM26 5l-4 1l1-4z" /><path fill="#77B255" d="M31.999 13L36 7.999L33 6z" /></svg>
                                <span> Congrats! Token successfully claimed.</span>
                                <br></br>

                            </h3>
                        </div>
                    </>
                    :
                    <></>
                }
            </Modal>

        </>
    );
}

export default DailyRewards;